/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable no-mixed-spaces-and-tabs */
/*************************************************
 * Tvastar
 * @exports
 * @file Dashboard.js
 * @author Prakash // on 07/01/2020
 * @copyright © 2019 Tvastar. All rights reserved.
 *************************************************/
import React, { Component } from 'react'
import { AppWrapper } from '../common/AppWrapper'
import * as d3 from 'd3'
import { capitalizeFirstLetter } from '../../utils/utility'

// const data1 = [{"State":"AL","Under 5 Years":310504,"5 to 13 Years":552339,"14 to 17 Years":259034,"18 to 24 Years":450818,"25 to 44 Years":1231572,"45 to 64 Years":1215966,"65 Years and Over":641667,"total":4661900},{"State":"AK","Under 5 Years":52083,"5 to 13 Years":85640,"14 to 17 Years":42153,"18 to 24 Years":74257,"25 to 44 Years":198724,"45 to 64 Years":183159,"65 Years and Over":50277,"total":686293},{"State":"AZ","Under 5 Years":515910,"5 to 13 Years":828669,"14 to 17 Years":362642,"18 to 24 Years":601943,"25 to 44 Years":1804762,"45 to 64 Years":1523681,"65 Years and Over":862573,"total":6500180},{"State":"AR","Under 5 Years":202070,"5 to 13 Years":343207,"14 to 17 Years":157204,"18 to 24 Years":264160,"25 to 44 Years":754420,"45 to 64 Years":727124,"65 Years and Over":407205,"total":2855390},{"State":"CA","Under 5 Years":2704659,"5 to 13 Years":4499890,"14 to 17 Years":2159981,"18 to 24 Years":3853788,"25 to 44 Years":10604510,"45 to 64 Years":8819342,"65 Years and Over":4114496,"total":36756666},{"State":"CO","Under 5 Years":358280,"5 to 13 Years":587154,"14 to 17 Years":261701,"18 to 24 Years":466194,"25 to 44 Years":1464939,"45 to 64 Years":1290094,"65 Years and Over":511094,"total":4939456},{"State":"CT","Under 5 Years":211637,"5 to 13 Years":403658,"14 to 17 Years":196918,"18 to 24 Years":325110,"25 to 44 Years":916955,"45 to 64 Years":968967,"65 Years and Over":478007,"total":3501252},{"State":"DE","Under 5 Years":59319,"5 to 13 Years":99496,"14 to 17 Years":47414,"18 to 24 Years":84464,"25 to 44 Years":230183,"45 to 64 Years":230528,"65 Years and Over":121688,"total":873092},{"State":"DC","Under 5 Years":36352,"5 to 13 Years":50439,"14 to 17 Years":25225,"18 to 24 Years":75569,"25 to 44 Years":193557,"45 to 64 Years":140043,"65 Years and Over":70648,"total":591833},{"State":"FL","Under 5 Years":1140516,"5 to 13 Years":1938695,"14 to 17 Years":925060,"18 to 24 Years":1607297,"25 to 44 Years":4782119,"45 to 64 Years":4746856,"65 Years and Over":3187797,"total":18328340},{"State":"GA","Under 5 Years":740521,"5 to 13 Years":1250460,"14 to 17 Years":557860,"18 to 24 Years":919876,"25 to 44 Years":2846985,"45 to 64 Years":2389018,"65 Years and Over":981024,"total":9685744},{"State":"HI","Under 5 Years":87207,"5 to 13 Years":134025,"14 to 17 Years":64011,"18 to 24 Years":124834,"25 to 44 Years":356237,"45 to 64 Years":331817,"65 Years and Over":190067,"total":1288198},{"State":"ID","Under 5 Years":121746,"5 to 13 Years":201192,"14 to 17 Years":89702,"18 to 24 Years":147606,"25 to 44 Years":406247,"45 to 64 Years":375173,"65 Years and Over":182150,"total":1523816},{"State":"IL","Under 5 Years":894368,"5 to 13 Years":1558919,"14 to 17 Years":725973,"18 to 24 Years":1311479,"25 to 44 Years":3596343,"45 to 64 Years":3239173,"65 Years and Over":1575308,"total":12901563},{"State":"IN","Under 5 Years":443089,"5 to 13 Years":780199,"14 to 17 Years":361393,"18 to 24 Years":605863,"25 to 44 Years":1724528,"45 to 64 Years":1647881,"65 Years and Over":813839,"total":6376792},{"State":"IA","Under 5 Years":201321,"5 to 13 Years":345409,"14 to 17 Years":165883,"18 to 24 Years":306398,"25 to 44 Years":750505,"45 to 64 Years":788485,"65 Years and Over":444554,"total":3002555},{"State":"KS","Under 5 Years":202529,"5 to 13 Years":342134,"14 to 17 Years":155822,"18 to 24 Years":293114,"25 to 44 Years":728166,"45 to 64 Years":713663,"65 Years and Over":366706,"total":2802134},{"State":"KY","Under 5 Years":284601,"5 to 13 Years":493536,"14 to 17 Years":229927,"18 to 24 Years":381394,"25 to 44 Years":1179637,"45 to 64 Years":1134283,"65 Years and Over":565867,"total":4269245},{"State":"LA","Under 5 Years":310716,"5 to 13 Years":542341,"14 to 17 Years":254916,"18 to 24 Years":471275,"25 to 44 Years":1162463,"45 to 64 Years":1128771,"65 Years and Over":540314,"total":4410796},{"State":"ME","Under 5 Years":71459,"5 to 13 Years":133656,"14 to 17 Years":69752,"18 to 24 Years":112682,"25 to 44 Years":331809,"45 to 64 Years":397911,"65 Years and Over":199187,"total":1316456},{"State":"MD","Under 5 Years":371787,"5 to 13 Years":651923,"14 to 17 Years":316873,"18 to 24 Years":543470,"25 to 44 Years":1556225,"45 to 64 Years":1513754,"65 Years and Over":679565,"total":5633597},{"State":"MA","Under 5 Years":383568,"5 to 13 Years":701752,"14 to 17 Years":341713,"18 to 24 Years":665879,"25 to 44 Years":1782449,"45 to 64 Years":1751508,"65 Years and Over":871098,"total":6497967},{"State":"MI","Under 5 Years":625526,"5 to 13 Years":1179503,"14 to 17 Years":585169,"18 to 24 Years":974480,"25 to 44 Years":2628322,"45 to 64 Years":2706100,"65 Years and Over":1304322,"total":10003422},{"State":"MN","Under 5 Years":358471,"5 to 13 Years":606802,"14 to 17 Years":289371,"18 to 24 Years":507289,"25 to 44 Years":1416063,"45 to 64 Years":1391878,"65 Years and Over":650519,"total":5220393},{"State":"MS","Under 5 Years":220813,"5 to 13 Years":371502,"14 to 17 Years":174405,"18 to 24 Years":305964,"25 to 44 Years":764203,"45 to 64 Years":730133,"65 Years and Over":371598,"total":2938618},{"State":"MO","Under 5 Years":399450,"5 to 13 Years":690476,"14 to 17 Years":331543,"18 to 24 Years":560463,"25 to 44 Years":1569626,"45 to 64 Years":1554812,"65 Years and Over":805235,"total":5911605},{"State":"MT","Under 5 Years":61114,"5 to 13 Years":106088,"14 to 17 Years":53156,"18 to 24 Years":95232,"25 to 44 Years":236297,"45 to 64 Years":278241,"65 Years and Over":137312,"total":967440},{"State":"NE","Under 5 Years":132092,"5 to 13 Years":215265,"14 to 17 Years":99638,"18 to 24 Years":186657,"25 to 44 Years":457177,"45 to 64 Years":451756,"65 Years and Over":240847,"total":1783432},{"State":"NV","Under 5 Years":199175,"5 to 13 Years":325650,"14 to 17 Years":142976,"18 to 24 Years":212379,"25 to 44 Years":769913,"45 to 64 Years":653357,"65 Years and Over":296717,"total":2600167},{"State":"NH","Under 5 Years":75297,"5 to 13 Years":144235,"14 to 17 Years":73826,"18 to 24 Years":119114,"25 to 44 Years":345109,"45 to 64 Years":388250,"65 Years and Over":169978,"total":1315809},{"State":"NJ","Under 5 Years":557421,"5 to 13 Years":1011656,"14 to 17 Years":478505,"18 to 24 Years":769321,"25 to 44 Years":2379649,"45 to 64 Years":2335168,"65 Years and Over":1150941,"total":8682661},{"State":"NM","Under 5 Years":148323,"5 to 13 Years":241326,"14 to 17 Years":112801,"18 to 24 Years":203097,"25 to 44 Years":517154,"45 to 64 Years":501604,"65 Years and Over":260051,"total":1984356},{"State":"NY","Under 5 Years":1208495,"5 to 13 Years":2141490,"14 to 17 Years":1058031,"18 to 24 Years":1999120,"25 to 44 Years":5355235,"45 to 64 Years":5120254,"65 Years and Over":2607672,"total":19490297},{"State":"NC","Under 5 Years":652823,"5 to 13 Years":1097890,"14 to 17 Years":492964,"18 to 24 Years":883397,"25 to 44 Years":2575603,"45 to 64 Years":2380685,"65 Years and Over":1139052,"total":9222414},{"State":"ND","Under 5 Years":41896,"5 to 13 Years":67358,"14 to 17 Years":33794,"18 to 24 Years":82629,"25 to 44 Years":154913,"45 to 64 Years":166615,"65 Years and Over":94276,"total":641481},{"State":"OH","Under 5 Years":743750,"5 to 13 Years":1340492,"14 to 17 Years":646135,"18 to 24 Years":1081734,"25 to 44 Years":3019147,"45 to 64 Years":3083815,"65 Years and Over":1570837,"total":11485910},{"State":"OK","Under 5 Years":266547,"5 to 13 Years":438926,"14 to 17 Years":200562,"18 to 24 Years":369916,"25 to 44 Years":957085,"45 to 64 Years":918688,"65 Years and Over":490637,"total":3642361},{"State":"OR","Under 5 Years":243483,"5 to 13 Years":424167,"14 to 17 Years":199925,"18 to 24 Years":338162,"25 to 44 Years":1044056,"45 to 64 Years":1036269,"65 Years and Over":503998,"total":3790060},{"State":"PA","Under 5 Years":737462,"5 to 13 Years":1345341,"14 to 17 Years":679201,"18 to 24 Years":1203944,"25 to 44 Years":3157759,"45 to 64 Years":3414001,"65 Years and Over":1910571,"total":12448279},{"State":"RI","Under 5 Years":60934,"5 to 13 Years":111408,"14 to 17 Years":56198,"18 to 24 Years":114502,"25 to 44 Years":277779,"45 to 64 Years":282321,"65 Years and Over":147646,"total":1050788},{"State":"SC","Under 5 Years":303024,"5 to 13 Years":517803,"14 to 17 Years":245400,"18 to 24 Years":438147,"25 to 44 Years":1193112,"45 to 64 Years":1186019,"65 Years and Over":596295,"total":4479800},{"State":"SD","Under 5 Years":58566,"5 to 13 Years":94438,"14 to 17 Years":45305,"18 to 24 Years":82869,"25 to 44 Years":196738,"45 to 64 Years":210178,"65 Years and Over":116100,"total":804194},{"State":"TN","Under 5 Years":416334,"5 to 13 Years":725948,"14 to 17 Years":336312,"18 to 24 Years":550612,"25 to 44 Years":1719433,"45 to 64 Years":1646623,"65 Years and Over":819626,"total":6214888},{"State":"TX","Under 5 Years":2027307,"5 to 13 Years":3277946,"14 to 17 Years":1420518,"18 to 24 Years":2454721,"25 to 44 Years":7017731,"45 to 64 Years":5656528,"65 Years and Over":2472223,"total":24326974},{"State":"UT","Under 5 Years":268916,"5 to 13 Years":413034,"14 to 17 Years":167685,"18 to 24 Years":329585,"25 to 44 Years":772024,"45 to 64 Years":538978,"65 Years and Over":246202,"total":2736424},{"State":"VT","Under 5 Years":32635,"5 to 13 Years":62538,"14 to 17 Years":33757,"18 to 24 Years":61679,"25 to 44 Years":155419,"45 to 64 Years":188593,"65 Years and Over":86649,"total":621270},{"State":"VA","Under 5 Years":522672,"5 to 13 Years":887525,"14 to 17 Years":413004,"18 to 24 Years":768475,"25 to 44 Years":2203286,"45 to 64 Years":2033550,"65 Years and Over":940577,"total":7769089},{"State":"WA","Under 5 Years":433119,"5 to 13 Years":750274,"14 to 17 Years":357782,"18 to 24 Years":610378,"25 to 44 Years":1850983,"45 to 64 Years":1762811,"65 Years and Over":783877,"total":6549224},{"State":"WV","Under 5 Years":105435,"5 to 13 Years":189649,"14 to 17 Years":91074,"18 to 24 Years":157989,"25 to 44 Years":470749,"45 to 64 Years":514505,"65 Years and Over":285067,"total":1814468},{"State":"WI","Under 5 Years":362277,"5 to 13 Years":640286,"14 to 17 Years":311849,"18 to 24 Years":553914,"25 to 44 Years":1487457,"45 to 64 Years":1522038,"65 Years and Over":750146,"total":5627967},{"State":"WY","Under 5 Years":38253,"5 to 13 Years":60890,"14 to 17 Years":29314,"18 to 24 Years":53980,"25 to 44 Years":137338,"45 to 64 Years":147279,"65 Years and Over":65614,"total":532668}]
const data = {"name":"flare","children":[{"name":"analytics","children":[{"name":"cluster","children":[{"name":"AgglomerativeCluster","value":3938},{"name":"CommunityStructure","value":3812},{"name":"HierarchicalCluster","value":6714},{"name":"MergeEdge","value":743}]},{"name":"graph","children":[{"name":"BetweennessCentrality","value":3534},{"name":"LinkDistance","value":5731},{"name":"MaxFlowMinCut","value":7840},{"name":"ShortestPaths","value":5914},{"name":"SpanningTree","value":3416}]},{"name":"optimization","children":[{"name":"AspectRatioBanker","value":7074}]}]},{"name":"animate","children":[{"name":"Easing","value":17010},{"name":"FunctionSequence","value":5842},{"name":"interpolate","children":[{"name":"ArrayInterpolator","value":1983},{"name":"ColorInterpolator","value":2047},{"name":"DateInterpolator","value":1375},{"name":"Interpolator","value":8746},{"name":"MatrixInterpolator","value":2202},{"name":"NumberInterpolator","value":1382},{"name":"ObjectInterpolator","value":1629},{"name":"PointInterpolator","value":1675},{"name":"RectangleInterpolator","value":2042}]},{"name":"ISchedulable","value":1041},{"name":"Parallel","value":5176},{"name":"Pause","value":449},{"name":"Scheduler","value":5593},{"name":"Sequence","value":5534},{"name":"Transition","value":9201},{"name":"Transitioner","value":19975},{"name":"TransitionEvent","value":1116},{"name":"Tween","value":6006}]},{"name":"data","children":[{"name":"converters","children":[{"name":"Converters","value":721},{"name":"DelimitedTextConverter","value":4294},{"name":"GraphMLConverter","value":9800},{"name":"IDataConverter","value":1314},{"name":"JSONConverter","value":2220}]},{"name":"DataField","value":1759},{"name":"DataSchema","value":2165},{"name":"DataSet","value":586},{"name":"DataSource","value":3331},{"name":"DataTable","value":772},{"name":"DataUtil","value":3322}]},{"name":"display","children":[{"name":"DirtySprite","value":8833},{"name":"LineSprite","value":1732},{"name":"RectSprite","value":3623},{"name":"TextSprite","value":10066}]},{"name":"flex","children":[{"name":"FlareVis","value":4116}]},{"name":"physics","children":[{"name":"DragForce","value":1082},{"name":"GravityForce","value":1336},{"name":"IForce","value":319},{"name":"NBodyForce","value":10498},{"name":"Particle","value":2822},{"name":"Simulation","value":9983},{"name":"Spring","value":2213},{"name":"SpringForce","value":1681}]},{"name":"query","children":[{"name":"AggregateExpression","value":1616},{"name":"And","value":1027},{"name":"Arithmetic","value":3891},{"name":"Average","value":891},{"name":"BinaryExpression","value":2893},{"name":"Comparison","value":5103},{"name":"CompositeExpression","value":3677},{"name":"Count","value":781},{"name":"DateUtil","value":4141},{"name":"Distinct","value":933},{"name":"Expression","value":5130},{"name":"ExpressionIterator","value":3617},{"name":"Fn","value":3240},{"name":"If","value":2732},{"name":"IsA","value":2039},{"name":"Literal","value":1214},{"name":"Match","value":3748},{"name":"Maximum","value":843},{"name":"methods","children":[{"name":"add","value":593},{"name":"and","value":330},{"name":"average","value":287},{"name":"count","value":277},{"name":"distinct","value":292},{"name":"div","value":595},{"name":"eq","value":594},{"name":"fn","value":460},{"name":"gt","value":603},{"name":"gte","value":625},{"name":"iff","value":748},{"name":"isa","value":461},{"name":"lt","value":597},{"name":"lte","value":619},{"name":"max","value":283},{"name":"min","value":283},{"name":"mod","value":591},{"name":"mul","value":603},{"name":"neq","value":599},{"name":"not","value":386},{"name":"or","value":323},{"name":"orderby","value":307},{"name":"range","value":772},{"name":"select","value":296},{"name":"stddev","value":363},{"name":"sub","value":600},{"name":"sum","value":280},{"name":"update","value":307},{"name":"variance","value":335},{"name":"where","value":299},{"name":"xor","value":354},{"name":"_","value":264}]},{"name":"Minimum","value":843},{"name":"Not","value":1554},{"name":"Or","value":970},{"name":"Query","value":13896},{"name":"Range","value":1594},{"name":"StringUtil","value":4130},{"name":"Sum","value":791},{"name":"Variable","value":1124},{"name":"Variance","value":1876},{"name":"Xor","value":1101}]},{"name":"scale","children":[{"name":"IScaleMap","value":2105},{"name":"LinearScale","value":1316},{"name":"LogScale","value":3151},{"name":"OrdinalScale","value":3770},{"name":"QuantileScale","value":2435},{"name":"QuantitativeScale","value":4839},{"name":"RootScale","value":1756},{"name":"Scale","value":4268},{"name":"ScaleType","value":1821},{"name":"TimeScale","value":5833}]},{"name":"util","children":[{"name":"Arrays","value":8258},{"name":"Colors","value":10001},{"name":"Dates","value":8217},{"name":"Displays","value":12555},{"name":"Filter","value":2324},{"name":"Geometry","value":10993},{"name":"heap","children":[{"name":"FibonacciHeap","value":9354},{"name":"HeapNode","value":1233}]},{"name":"IEvaluable","value":335},{"name":"IPredicate","value":383},{"name":"IValueProxy","value":874},{"name":"math","children":[{"name":"DenseMatrix","value":3165},{"name":"IMatrix","value":2815},{"name":"SparseMatrix","value":3366}]},{"name":"Maths","value":17705},{"name":"Orientation","value":1486},{"name":"palette","children":[{"name":"ColorPalette","value":6367},{"name":"Palette","value":1229},{"name":"ShapePalette","value":2059},{"name":"SizePalette","value":2291}]},{"name":"Property","value":5559},{"name":"Shapes","value":19118},{"name":"Sort","value":6887},{"name":"Stats","value":6557},{"name":"Strings","value":22026}]},{"name":"vis","children":[{"name":"axis","children":[{"name":"Axes","value":1302},{"name":"Axis","value":24593},{"name":"AxisGridLine","value":652},{"name":"AxisLabel","value":636},{"name":"CartesianAxes","value":6703}]},{"name":"controls","children":[{"name":"AnchorControl","value":2138},{"name":"ClickControl","value":3824},{"name":"Control","value":1353},{"name":"ControlList","value":4665},{"name":"DragControl","value":2649},{"name":"ExpandControl","value":2832},{"name":"HoverControl","value":4896},{"name":"IControl","value":763},{"name":"PanZoomControl","value":5222},{"name":"SelectionControl","value":7862},{"name":"TooltipControl","value":8435}]},{"name":"data","children":[{"name":"Data","value":20544},{"name":"DataList","value":19788},{"name":"DataSprite","value":10349},{"name":"EdgeSprite","value":3301},{"name":"NodeSprite","value":19382},{"name":"render","children":[{"name":"ArrowType","value":698},{"name":"EdgeRenderer","value":5569},{"name":"IRenderer","value":353},{"name":"ShapeRenderer","value":2247}]},{"name":"ScaleBinding","value":11275},{"name":"Tree","value":7147},{"name":"TreeBuilder","value":9930}]},{"name":"events","children":[{"name":"DataEvent","value":2313},{"name":"SelectionEvent","value":1880},{"name":"TooltipEvent","value":1701},{"name":"VisualizationEvent","value":1117}]},{"name":"legend","children":[{"name":"Legend","value":20859},{"name":"LegendItem","value":4614},{"name":"LegendRange","value":10530}]},{"name":"operator","children":[{"name":"distortion","children":[{"name":"BifocalDistortion","value":4461},{"name":"Distortion","value":6314},{"name":"FisheyeDistortion","value":3444}]},{"name":"encoder","children":[{"name":"ColorEncoder","value":3179},{"name":"Encoder","value":4060},{"name":"PropertyEncoder","value":4138},{"name":"ShapeEncoder","value":1690},{"name":"SizeEncoder","value":1830}]},{"name":"filter","children":[{"name":"FisheyeTreeFilter","value":5219},{"name":"GraphDistanceFilter","value":3165},{"name":"VisibilityFilter","value":3509}]},{"name":"IOperator","value":1286},{"name":"label","children":[{"name":"Labeler","value":9956},{"name":"RadialLabeler","value":3899},{"name":"StackedAreaLabeler","value":3202}]},{"name":"layout","children":[{"name":"AxisLayout","value":6725},{"name":"BundledEdgeRouter","value":3727},{"name":"CircleLayout","value":9317},{"name":"CirclePackingLayout","value":12003},{"name":"DendrogramLayout","value":4853},{"name":"ForceDirectedLayout","value":8411},{"name":"IcicleTreeLayout","value":4864},{"name":"IndentedTreeLayout","value":3174},{"name":"Layout","value":7881},{"name":"NodeLinkTreeLayout","value":12870},{"name":"PieLayout","value":2728},{"name":"RadialTreeLayout","value":12348},{"name":"RandomLayout","value":870},{"name":"StackedAreaLayout","value":9121},{"name":"TreeMapLayout","value":9191}]},{"name":"Operator","value":2490},{"name":"OperatorList","value":5248},{"name":"OperatorSequence","value":4190},{"name":"OperatorSwitch","value":2581},{"name":"SortOperator","value":2023}]},{"name":"Visualization","value":16540}]}]}

const lollipopData = [
  {group: 'A', var1: 12, var2: 15},
  {group: 'B', var1: 23, var2: 27},
  {group: 'C', var1: 4, var2: 8},
  {group: 'D', var1: 8, var2: 14},
  {group: 'E', var1: 9, var2: 20},
  {group: 'F', var1: 10, var2: 15},
  {group: 'G', var1: 2, var2: 8},
  {group: 'H', var1: 3, var2: 10},
  {group: 'I', var1: 12, var2: 20},
  {group: 'J', var1: 22, var2: 38}
]

const lollipopHorizData = [
  {group: 'A', var1: 12, var2: 15},
  {group: 'B', var1: 23, var2: 27},
  {group: 'C', var1: 4, var2: 8},
  {group: 'D', var1: 8, var2: 14}
]

const lollipopHorizDataNew = [
  {group: 'getNodeByDegree', var1: 12, var2: 15},
  {group: 'Expected', var1: 23, var2: 27},
  {group: 'assigned', var1: 4, var2: 8},
  {group: 'return', var1: 8, var2: 14}
]

// const self = this
class VisGraph extends Component {
	hierarchialBarChartRef = React.createRef()
  constructor() {
    super();
    this.state = {
      sunburstData: [] 
    } 
    // this.click2 = this.click2.bind(this);
  }

  componentDidMount = () => {
    // console.log('daxta2', data2)
    // this.drawChart();

    this.hierarchicalchart()
    this.lollipopChart()
    this.horizontalLollipopChart()
    this.horizontalLimitLollipopChart()
    this.createLineSvg()
  }

  createLineSvg = () => {
    // var margin = {top: 30, right: 30, bottom: 70, left: 60},
    // width = 460 - margin.left - margin.right,
    // height = 400 - margin.top - margin.bottom;

        // .attr("width", width + margin.left + margin.right)
        // .attr("height", height + margin.top + margin.bottom)
    var svg = d3.select("#lineSvg")
        .append("svg")
        .attr("width", 200)
        .attr("height", 20)
              
    svg.append("line")
        .attr("x1", 0)
        .attr("x2", 100)
        .attr("y1", 10)
        .attr("y2", 10)
        .attr("stroke", "red")
        .attr("stroke-width", 2)

    svg.append("line")
        .attr("x1", 105)
        .attr("x2", 155 )
        .attr("y1", 10)
        .attr("y2", 10)
        .attr("stroke", "green")
        .attr("stroke-width", 2)

     // Circles
     svg.append("circle")
        .attr("cx", 105)
        .attr("cy", 10)
        .attr("r", "4")
        .attr("fill", "none")
        .attr("stroke", "black")
        .attr("stroke-width", 5)
        .attr('storke', '#69b3a2')

    // Circles of variable 2
    svg.append("circle")
        .attr("cx", 160)
        .attr("cy", 10)
        .attr("r", "6")
        .attr("fill", "none")
        .attr("stroke", "black")
        .attr("stroke-width", 5)
        .attr('storke', '#4C4082')
    svg.append("text")
        .attr("transform", "translate(-10,0)rotate(-45)")
        .style("text-anchor", "end");
        
  }

  lollipopChart = () => {
    var margin = {top: 30, right: 30, bottom: 70, left: 60},
    width = 460 - margin.left - margin.right,
    height = 400 - margin.top - margin.bottom;

    // append the svg object to the body of the page
    var svg = d3.select("#lollipopChart")
      .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
      .append("g")
        .attr("transform",
              "translate(" + margin.left + "," + margin.top + ")");

    // Initialize the X axis
    var x = d3.scaleBand()
      .range([ 0, width ])
      .padding(1);
    var xAxis = svg.append("g")
      // .attr('id', 'xaxis-path')
      .attr("transform", "translate(0," + height + ")")
    // Initialize the Y axis
    var y = d3.scaleLinear()
      .range([ height, 0]);

    // var color = d3.scaleOrdinal()
    //   .domain(lollipopData.map(d => d.group))
    //   .range(["#6b486b", "red"]);
    var color = d3.scaleOrdinal()
          .range(["#eb6383", "#fa9191", "#ffe9c5", "#b4f2e1"]);

    var yAxis = svg.append("g")
      .attr("class", "myYaxis")

    x.domain(lollipopData.map(function(d) { return d.group; }))
    xAxis.transition().duration(1000).call(d3.axisBottom(x))
    .call(g => g.select(".domain").remove())

    // xAxis.selectAll(".tick").append("circle")
      // .attr("cx", function(d) { return x(d.group); })
      // .attr("cy", function(d) { return y(d[selectedVar]); })
      // .attr("font-size","20")
      // .attr("rotate","15")
      // .attr("font-family","cursive");

    let selectedVar = 'var1'
    

    // Add Y axis
    y.domain([0, d3.max(lollipopData, function(d) { return +d[selectedVar] }) ]);
    yAxis.transition().duration(1000).call(d3.axisLeft(y));

    // variable u: map data to existing circle
    var j = svg.selectAll(".myLine")
      .data(lollipopData)
    // update lines
    j
      .enter()
      .append("line")
      .attr("class", "myLine")
      .merge(j)
      .transition()
      .duration(1000)
        .attr("x1", function(d) { console.log(x(d.group)) ; return x(d.group); })
        .attr("x2", function(d) { return x(d.group); })
        .attr("y1", y(0))
        .attr("y2", function(d) { return y(d[selectedVar]); })
        // .attr("stroke", "#9B9898")
        .attr('stroke', function(d, i) {
            return color(i);
        })
        // .style("stroke", "black")
        .attr("stroke-width", "2")


    // variable u: map data to existing circle
    var u = svg.selectAll("circle")
      .data(lollipopData)
    // update bars
    u
      .enter()
      .append("circle")
      .merge(u)
      .transition()
      .duration(1000)
        .attr("cx", function(d) { return x(d.group); })
        .attr("cy", function(d) { return y(d[selectedVar]) - 10; })
        .attr("r", 8)
        .attr("fill", "none")
        .attr("stroke-width", "5")
        // .attr("stroke", '#69b3a2')
        .attr('stroke', function(d, i) {
            return color(i);
        })
  }

  horizontalLollipopChart = () => {
    var margin = {top: 10, right: 30, bottom: 40, left: 100},
    width = 460 - margin.left - margin.right,
    height = 250 - margin.top - margin.bottom;

    // append the svg object to the body of the page
    var svg = d3.select("#horizontalLollipopChart")
      .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
      .append("g")
        .attr("transform",
              "translate(" + margin.left + "," + margin.top + ")");

    var x = d3.scaleLinear()
    .domain([0, 40])
    .range([ 0, width]);

    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x))
      .selectAll("text")
        .attr("transform", "translate(-10,0)rotate(-45)")
        .style("text-anchor", "end");

    // Y axis
    var y = d3.scaleBand()
      .range([ 0, height ])
      .domain(lollipopHorizData.map(function(d) { return d.group; }))
      .padding(1);
    svg.append("g")
      .call(d3.axisLeft(y))


    // Lines
    svg.selectAll("myline")
      .data(lollipopHorizData)
      .enter()
      .append("line")
        .attr("x1", function(d) { return x(d.var1); })
        .attr("x2", x(0))
        .attr("y1", function(d) { return y(d.group); })
        .attr("y2", function(d) { return y(d.group); })
        .attr("stroke", "grey")

      svg.selectAll("myline")
      .data(lollipopHorizData)
      .enter()
      .append("line")
        .attr("x1", function(d) { return x(d.var1); })
        .attr("x2", function(d) { return x(d.var2); })
        .attr("y1", function(d) { return y(d.group); })
        .attr("y2", function(d) { return y(d.group); })
        .attr("stroke", "lightgrey")
    

    // Circles
    svg.selectAll("mycircle")
      .data(lollipopHorizData)
      .enter()
      .append("circle")
        .attr("cx", function(d) { return x(d.var1); })
        .attr("cy", function(d) { return y(d.group); })
        .attr("r", "4")
        .style("fill", "#69b3a2")
        .attr("stroke", "black")

    // Circles of variable 2
    svg.selectAll("mycircle")
    .data(lollipopHorizData)
    .enter()
    .append("circle")
      .attr("cx", function(d) { return x(d.var2); })
      .attr("cy", function(d) { return y(d.group); })
      .attr("r", "6")
      .style("fill", "#4C4082")
  }

  hierarchicalchart = () => {
    var root = d3.hierarchy(data)
                  .sum(d => d.value)
                  .sort((a,b) => b.value - a.value);


    var duration = 750,
      delay = 25,
      barHeight = 20,
      // barStep = 27,
      // barPadding = 3 / barStep,
      margin = {top: 30, right: 120, bottom: 0, left: 120},
      width = 960 - margin.left - margin.right,
      height = 500 - margin.top - margin.bottom;
      // height = heightFunction()


    var x = d3.scaleLinear()
        .range([0, width]);    

    var color = d3.scaleOrdinal()
        .range(["#6b486b", "#ccc"]);
        // .range(["steelblue", "#ccc"]);

    var partition = d3.partition();


    var xAxis = d3.axisTop()
        .scale(x);

    var svg = d3.select("#hierarchialBarChart").append("svg")
        .attr("id","hieraricharlId")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
      .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    svg.append("rect")
        .attr("class", "background")
        .attr('id', "background")
        // .attr('id', function(d) { return d.data.State })
        .attr("width", width)
        .attr("height", height)
        // .on("click", up);
        .on("click", (event, d) => up(d, 0))

    svg.append("g")
        .attr("class", "x axis")
        

    svg.append("g")
        .attr("class", "y axis")
      .append("line")
        .attr("y1", "100%");


    let tooltip = d3.select("#hierarchialBarChart").append("text").attr("id", "tooltip")

    partition(root);
    
    x.domain([0, root.value]).nice();
    
    down(root, 0);

    // function heightFunction(type, child) {
    //   let length = 0
    //   if(type === 'up') {
    //     length = child.children.length
    //   } else {
    //     length = child.length
    //   }
    //   let max = 1;
    //   root.each(d => d.children && (max = Math.max(max, d.children.length)));
    //   let newHeight = max * barStep - margin.top - margin.bottom;
    //   if(length > 20) {
    //     return newHeight
    //   } else {
    //     return 500
    //   }
    // }

    function barHeightFunction(type, child) {
      let length = 0
      if(type === 'up') {
        length = child.children.length
      } else {
        length = child.length
      }
      let max = 1;
      root.each(d => d.children && (max = Math.max(max, d.children.length)));
      let newHeight = 20

      if(length > 40) {
        newHeight = 7
      } else if(length > 40) {
        newHeight = 10
      } else if(length > 25) {
        newHeight = 12
      } else if(length > 20) {
        newHeight = 18
      }
      return newHeight
    }
    
    function down(d, i) {  
      if (!d.children) return;

      // height = heightFunction('down', d.children)
      // var svg = d3.select("#hieraricharlId")
      //   .attr("width", width + margin.left + margin.right)
      //   .attr("height", height + margin.top + margin.bottom)
      // var react = d3.select("#background")
      //   .attr("width", width + margin.left + margin.right)
      //   .attr("height", height + margin.top + margin.bottom)

      barHeight = barHeightFunction('down', d.children)

      var end = duration + d.children.length * delay;
    
      // Mark any currently-displayed bars as exiting.
      var exit = svg.selectAll(".enter")
          .attr("class", "exit");
    
      // Entering nodes immediately obscure the clicked-on bar, so hide it.
      exit.selectAll("rect").filter(function(p) { return p === d; })
          .style("fill-opacity", 1e-6);
    
      // Enter the new bars for the clicked-on data.
      // Per above, entering bars are immediately visible.
      var enter = bar(d)
          .attr("transform", stack(i))
          .style("opacity", 1);
    
      // Have the text fade-in, even though the bars are visible.
      // Color the bars as parents; they will fade to children if appropriate.
      enter.select("text").style("fill-opacity", 1e-6);
      enter.select("rect").style("fill", color(true))
        .on("mouseover", function (actual, i) {
          d3.select('.enter').selectAll(`rect`).style('opacity', 0.5);
          d3.select(this).style('opacity', 1)
          tooltip.style("display", "inline-block")
        })
        .on("mouseout", d => {     
          tooltip.style("display", "none")
          d3.select('#hieraricharlId')
            .selectAll(`rect`)
            .style('opacity', 1);
        })
        .on("mousemove", function(event, d) {
          console.log('event', event)
          // var xPosition = d3.pointer(event)[0]
          // var yPosition = d3.pointer(event)[1] - height

          // var coords = d3.pointer( event );
          // var xPosition = coords[0];
          // var yPosition = coords[1];
          let hoverContent = capitalizeFirstLetter(d.data.name)+' '+d.value
          // tooltip.html(hoverContent)
          // tooltip.attr("transform", "translate("+xPosition+", "+yPosition+")");

          // const text = d3.select('#tooltip');
          tooltip.text(hoverContent);
          tooltip
            .style('transform', `translate(${event.pageX - 50}px, ${event.pageY-(height+100)}px)`);
        });
      // Update the x-scale domain.
      x.domain([0, d3.max(d.children, function(d) { return d.value; })]).nice();
    
      // Update the x-axis.
      svg.selectAll(".x.axis").transition()
          .duration(duration)
          .call(xAxis);
    
      // Transition entering bars to their new position.
      var enterTransition = enter.transition()
          .duration(duration)
          .delay(function(d, i) { return i * delay; })
          .attr("transform", function(d, i) { return "translate(0," + barHeight * i * 1.2 + ")"; });
    
      // Transition entering text.
      enterTransition.select("text")
          .style("fill-opacity", 1);
    
      // Transition entering rects to the new x-scale.
      enterTransition.select("rect")
          .attr("width", function(d) { return x(d.value); })
          .style("fill", function(d) { return color(!!d.children); });
    
      // Transition exiting bars to fade out.
      var exitTransition = exit.transition()
          .duration(duration)
          .style("opacity", 1e-6)
          .remove();
    
      // Transition exiting bars to the new x-scale.
      exitTransition.selectAll("rect")
          .attr("width", function(d) { return x(d.value); });
    
      // Rebind the current node to the background.
      svg.select(".background")
          .datum(d)
        .transition()
          .duration(end);
    
      d.index = i;
    }
    
    function up(d) {
      
      if (!d.parent) return;
      // height = heightFunction('up', d.parent)
      // var svg = d3.select("#hieraricharlId")
      //   .attr("width", width + margin.left + margin.right)
      //   .attr("height", height + margin.top + margin.bottom)
      // var react = d3.select("#background")
      //   .attr("width", width + margin.left + margin.right)
      //   .attr("height", height + margin.top + margin.bottom)
      
      barHeight = barHeightFunction('up', d.parent)
      
      var end = duration + d.children.length * delay;
    
      // Mark any currently-displayed bars as exiting.
      var exit = svg.selectAll(".enter")
          .attr("class", "exit");
    
      // Enter the new bars for the clicked-on data's parent.
      var enter = bar(d.parent)
          .attr("transform", function(d, i) { return "translate(0," + barHeight * i * 1.2 + ")"; })
          .style("opacity", 1e-6);
    
      // Color the bars as appropriate.
      // Exiting nodes will obscure the parent bar, so hide it.
      enter.select("rect")
          .style("fill", function(d) { return color(!!d.children); })
          .on("mouseover", function (actual, i) {
            d3.select('.enter').selectAll(`rect`).style('opacity', 0.5);
            d3.select(this).style('opacity', 1)
            tooltip.style("display", "inline-block")
          })
          .on("mouseout", d => {     
            tooltip.style("display", "none")
            d3.select('#hieraricharlId')
              .selectAll(`rect`)
              .style('opacity', 1);
          })
          .on("mousemove", function(event, d) {
            console.log('event', event)
            // var xPosition = d3.pointer(event)[0]
            // var yPosition = d3.pointer(event)[1] - height
  
            // var coords = d3.pointer( event );
            // var xPosition = coords[0];
            // var yPosition = coords[1];
            let hoverContent = capitalizeFirstLetter(d.data.name)+' '+d.value
            // tooltip.html(hoverContent)
            // tooltip.attr("transform", "translate("+xPosition+", "+yPosition+")");
  
            // const text = d3.select('#tooltip');
            tooltip.text(hoverContent);
            tooltip
              .style('transform', `translate(${event.pageX - 50}px, ${event.pageY-(height+100)}px)`);
          })
        .filter(function(p) { return p === d; })
          .style("fill-opacity", 1e-6);
    
      // Update the x-scale domain.
      x.domain([0, d3.max(d.parent.children, function(d) { return d.value; })]).nice();
    
      // Update the x-axis.
      svg.selectAll(".x.axis").transition()
          .duration(duration)
          .call(xAxis);
    
      // Transition entering bars to fade in over the full duration.
      var enterTransition = enter.transition()
          .duration(end)
          .style("opacity", 1);
    
      // Transition entering rects to the new x-scale.
      // When the entering parent rect is done, make it visible!
      enterTransition.select("rect")
          .attr("width", function(d) { return x(d.value); })
          .on("end",function(p) { if (p === d) d3.select(this).style("fill-opacity", null); });
    
      // Transition exiting bars to the parent's position.
      var exitTransition = exit.selectAll("g").transition()
          .duration(duration)
          .delay(function(d, i) { return i * delay; })
          .attr("transform", stack(d.index));
    
      // Transition exiting text to fade out.
      exitTransition.select("text")
          .style("fill-opacity", 1e-6);
    
      // Transition exiting rects to the new scale and fade to parent color.
      exitTransition.select("rect")
          .attr("width", function(d) { return x(d.value); })
          .style("fill", color(true));
    
      // Remove exiting nodes when the last child has finished transitioning.
      exit.transition()
          .duration(end)
          .remove();
    
      // Rebind the current parent to the background.
      svg.select(".background")
          .datum(d.parent)
        .transition()
          .duration(end);
    }
    
    // Creates a set of bars for the given data node, at the specified index.
    function bar(d) {
      var bar = svg.insert("g", ".y.axis")
          .attr("class", "enter")
          .attr("transform", "translate(0,5)")
        .selectAll("g")
          .data(d.children)
        .enter().append("g")
          .style("cursor", function(d) { return !d.children ? null : "pointer"; })
          .on("click", (event, d) => down(d, 0));
    
      bar.append("text")
          .attr("x", -6)
          .attr("y", barHeight / 2)
          .attr("dy", ".35em")
          .style("text-anchor", "end")
          .text(function(d) { return d.data.name; });
    
      bar.append("rect")
          .attr("width", function(d) { return x(d.value); })
          .attr("height", barHeight)
          .attr("d", function(d) {
            // return rightRoundedRect(x(0), y(d.name), x(d.value) - x(0), y.rangeBand(), 10);
            return rightRoundedRect(-240, -120, 480, 240, 20)
          })
    
      return bar;
    }

    function rightRoundedRect(x, y, width, height, radius) {
      return "M" + x + "," + y
           + "h" + (width - radius)
           + "a" + radius + "," + radius + " 0 0 1 " + radius + "," + radius
           + "v" + (height - 2 * radius)
           + "a" + radius + "," + radius + " 0 0 1 " + -radius + "," + radius
           + "h" + (radius - width)
           + "z";
    }

    
    // A stateful closure for stacking bars horizontally.
    function stack(i) {
      var x0 = 0;
      return function(d) {
        var tx = "translate(" + x0 + "," + barHeight * i * 1.2 + ")";
        x0 += x(d.value);
        return tx;
      };
    }
  }

  horizontalLimitLollipopChart = () => {
    var margin = {top: 10, right: 30, bottom: 40, left: 10},
    width = 600 - margin.left - margin.right,
    height = 250 - margin.top - margin.bottom;

    let circleStroke = 3
    let circleInnerStroke = 4
    
    // append the svg object to the body of the page
    var svg = d3.select("#horizontalLimitLollipopChart")
      .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
      .append("g")
        .attr("transform",
              "translate(" + margin.left + "," + margin.top + ")");

    var color = d3.scaleOrdinal()
      .range(["#eb6383", "#fa9191", "#6B486B", "#b4f2e1"]);
    
    // var secodaryColor = d3.scaleOrdinal()
    // .range(["#eb6383", "#fa9191", "#6B486B", "#b4f2e1"]);
    
    var x = d3.scaleLinear()
    .domain([0, 40])
    .range([ 0, width]);

    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      // .call(d3.axisBottom(x))
      .selectAll("text")
        .attr("transform", "translate(-10,0)rotate(-45)")
        .style("text-anchor", "top");

    // Y axis
    var y = d3.scaleBand()
      .range([ 0, height ])
      .domain(lollipopHorizDataNew.map(function(d) { return d.group; }))
      .padding(1);
    // svg.append("g")
    //   .call(d3.axisLeft(y))


    // Lines
    svg.selectAll("myline")
      .data(lollipopHorizDataNew)
      .enter()
      .append("line")
        .attr("x1", function(d) { return x(d.var1); })
        .attr("x2", x(0))
        .attr("y1", function(d) { return y(d.group); })
        .attr("y2", function(d) { return y(d.group); })
        // .attr("stroke", "grey")
        .attr('stroke', function(d, i) {
            return color(i);
        })

    svg.selectAll("myline")
      .data(lollipopHorizDataNew)
      .enter()
      .append("line")
        .attr("x1", function(d) { return x(d.var1) + (circleStroke * 2); })
        .attr("x2", function(d) { return x(d.var2); })
        .attr("y1", function(d) { return y(d.group); })
        .attr("y2", function(d) { return y(d.group); })
        .attr("stroke", "lightgrey")
    

    // Circles
    svg.selectAll("mycircle")
      .data(lollipopHorizDataNew)
      .enter()
      .append("circle")
        .attr("cx", function(d) { return x(d.var1) + circleStroke; })
        .attr("cy", function(d) { return y(d.group); })
        .attr("r", "6")
        .style("fill", "none")
        // .attr("stroke", "black")
        .attr("stroke-width", circleStroke)
        .attr('stroke', function(d, i) {
          return color(i);
        })
    
    svg.selectAll("mycircle")
      .data(lollipopHorizDataNew)
      .enter()
      .append("circle")
        .attr("cx", function(d) { return x(d.var1) + circleStroke; })
        .attr("cy", function(d) { return y(d.group); })
        .attr("r", "1")
        .style('fill', function(d, i) {
          return color(i);
        })
        // .attr("stroke", "black")
        .attr("stroke-width", circleInnerStroke)
        .attr('stroke', function(d, i) {
          return color(i);
        })

    // Circles of variable 2
    svg.selectAll("mycircle")
      .data(lollipopHorizDataNew)
      .enter()
      .append("circle")
        .attr("cx", function(d) { return x(d.var2) + circleStroke; })
        .attr("cy", function(d) { return y(d.group); })
        .attr("r", "6")
        .style("fill", "none")
        .attr("stroke-width", circleStroke)
        .attr("stroke", "lightgrey")
        // .attr('stroke', function(d, i) {
        //   return secodaryColor(i);
        // })

    svg.selectAll("myline")
      .data(lollipopHorizDataNew)
      .enter()
      .append("text")
          .attr("x", x(0) )
          .attr("y", function(d) { return y(d.group) - 10; })
          .attr("font-size", "10px")
          .style("text-anchor", "sart")
          .text(function(d) { return d.group; });
  }


  drawChart = () => {
    let hoverContent = ''
    let keys = ["Under 5 Years", "5 to 13 Years", "14 to 17 Years", "18 to 24 Years", "25 to 44 Years", "45 to 64 Years", "65 Years and Over"]
    const stackGenerator = d3.stack().keys(keys);
    const layers = stackGenerator(data);

    // This is our min/max values
    // const extent = [
    // 0,
    // d3.max(layers, (layer) => d3.max(layer, (sequence) => sequence[1] + 0.2))
    // ];

    // var svgContainer = d3.select('#stackbarChart')
    
    var svg = d3.select("svg"),
      width = 700,
      height = 700,
      innerRadius = 90,
      outerRadius = Math.min(width, height) / 2,
      g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    console.log(svg,'svg')

    svg.attr("transform", "translate(0,0)") //to center the chart
    let tooltip = d3.select("#tooltip")

    // var tooltip = svg.append("g")
    //   .attr("class", "tooltip")
    //   .style("display", "none");
        
    // tooltip.append("rect")
    //   .attr("width", 60)
    //   .attr("height", 20)
    //   .attr("fill", "white")
    //   .style("opacity", 0.5);

    // tooltip.append("text")
    //   .attr("x", 30)
    //   .attr("dy", "1.2em")
    //   .style("text-anchor", "middle")
    //   .attr("font-size", "12px")
    //   .attr("font-weight", "bold");
      
      
    // legend for hover center label  prakash

    // var legend = g.append("g").selectAll("g")
    //   .data('D')
    //   .enter().append("g")
    //     .attr("transform", "translate(-00," + 1 * 20 + ")");

    //   // legend.append("foreignObject")
    //   //     .attr("x", "-10%")
    //   //     .attr("y", "-3%")
    //   legend.append("text")
    //   .attr("x", "-10%")
    //   .attr("y", "-3%")
    //   .attr("dy", "0.35em")
    //   .text("");
    
    // legend for hover center label  prakash


    var x = d3.scaleBand()
      .domain(data.map(d => d.State))
      .range([0, 2 * Math.PI])
      .align(0)

    var y = d3.scaleRadial()
      .domain([0, d3.max(data, d => d.total)])
      .range([innerRadius, outerRadius]);
      
    var z = d3
      .scaleOrdinal()
      .domain(data.map(d => d.state))
      .range(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"]);
    x.domain(data.map(function(d) { return d.State; }));
    y.domain([0, d3.max(data, function(d) { return d.total; })]);
    z.domain(keys);

    g.append("g")
      .selectAll("g")
      .data(layers)
      .enter().append("g")
        .attr("fill", function(d) { return z(d.key); }) 
      .selectAll("path")
      .data(function(d) { return d; })
      .enter().append("path")
          .attr('id', function(d) { return d.data.State })
          .attr("d", d3.arc()
            .innerRadius(function(d) { return y(d[0]); })
            .outerRadius(function(d) { return y(d[1]); })
            .startAngle(function(d) { return x(d.data.State); })
            .endAngle(function(d) { return x(d.data.State) + x.bandwidth(); })
            .padAngle(0.01)
            .padRadius(innerRadius))
      .on("mouseover", d => { 
        tooltip.style("display", "inline-block");
        d3.select('svg')
          .selectAll(`path`)
          .style('opacity', 0.5);

        let hoverData = d.path[0].__data__
        let hoverState = ''
        if(hoverData.data && Object.entries(hoverData.data).length) {
          hoverState = hoverData.data.State
        }

        d3.select('svg')
        .selectAll(`path[id=${hoverState}]`)
        .style('opacity', 1);

        this.click2(hoverData);

      })
      .on("mouseout", function() { 
        
        // legend.select("text").text('');  // legend for hover center label prakash
        tooltip.style("display", "none"); 
        d3.select('svg')
        .selectAll(`path`)
        .style('opacity', 1);
      })
      .on("mousemove", function(d) {
        // console.log('event', event);
        console.log('path1',d)
        // console.log('path2',d.path)
        // console.log('path3',d.path[0].nodeName)
        // console.log('path',d.path[0].__data__)
        let hoverData = d.path[0].__data__
        // console.log(hoverData)
        let hoverValue = hoverData[1]-hoverData[0]
        let hoverLabel = ''
        // let hoverState = ''
        if(hoverData.data && Object.entries(hoverData.data).length) {
          // hoverState = hoverData.data.State
          Object.entries(hoverData.data).forEach(([key, value]) => {
            if(hoverValue === value) {
              hoverLabel = key
            }
          })
        }
        // console.log(d3.pointer(event))
        var xPosition = d3.pointer(d)[0] - 330;
        var yPosition = d3.pointer(d)[1] + 15;
        console.log(hoverLabel, hoverValue)

        hoverContent = hoverLabel+' '+hoverValue+' '+hoverValue

        tooltip.html(hoverContent).style("transform", "translate("+xPosition+"px, "+yPosition+"px)");
        // tooltip.attr("transform", "translate(" + xPosition + "," + yPosition + ")");
        // tooltip.select("text").text(hoverContent);
        
        // legend.select("text").text(hoverContent); // legend for hover center label  prakash

        // click2(hoverData)
      })
      // .on("click", d => {
      //   let hoverData = d.path[0].__data__
      //   // this.click2(hoverData);
      // });

    var yAxis = g.append("g")
      .attr("text-anchor", "middle");
  
    var yTick = yAxis
      .selectAll("g")
      .data(y.ticks(5).slice(1))
      .enter().append("g");
  
    yTick.append("circle")
      .attr("fill", "none")
      .attr("stroke", "#000")
      .attr("r", y);
  
    yTick.append("text")
      .attr("y", function(d) { return -y(d); })
      .attr("dy", "0.35em")
      .attr("fill", "none")
      .attr("stroke", "#fff")
      .attr("stroke-width", 5)
      .text(y.tickFormat(5, "s"));
  
    yTick.append("text")
      .attr("y", function(d) { return -y(d); })
      .attr("dy", "0.35em")
      .text(y.tickFormat(5, "s"));

    yAxis.append("text")
      .attr("y", function(d) { return -y(y.ticks(5).pop()); })
      .attr("dy", "-1em")
      // .text("Population");

    var legend = g.append("g")
      .selectAll("g")
      .data(keys.reverse())
      .enter().append("g")
        .attr("transform", function(d, i) { return "translate(-40," + (i - (keys.length - 1) / 2) * 20 + ")"; });

    // legend.append("rect")
    //     .attr("width", 18)
    //     .attr("height", 18)
    //     .attr("fill", z);
    
    legend.append("circle")
        .attr("r", 8)
        .attr("fill", z);

    legend.append("text")
        // .attr("x", 24)
        // .attr("y", 9)
        .attr("x", 15)
        .attr("y", 0)
        .attr("dy", "0.35em")
        .text(function(d) { return d; });

    
  }

  click2 = (hoverData) => {
    console.log('hoverData', hoverData)
    let dynamicColumns = []
    let sunburstData = hoverData.data ? hoverData.data : {}
    let dataRow = {}
    dataRow.Header = 'Data'
    dataRow.accessor = "!23123"
    dynamicColumns.push(dataRow)
    if(hoverData !== '' && hoverData.data && Object.entries(hoverData.data).length) {
      Object.entries(hoverData.data).forEach(([key, value], i) => {
      })

      if(!this.state.sunburstData.length && sunburstData !== this.state.sunburstData) {
        this.setState({ sunburstData })
      }
    }
  }

  render() {
    return (
      <div className="container-fluid overflow-auto flex-grow-1">
        <div className="row">
          <div className="col-sm-6 displayNone" id="stackbarChart">
            <svg id="svg" width="700" height="700" font-family="sans-serif" font-size="10"></svg>
            <div id="tooltip"></div>
          </div>
          <div className="col-sm-6 rounded bg-white4 p-3 mt-2 displayNone">
            <p class="mb-0"><b>Distribution</b></p>
            <p class="small mb-2">Showing the distribution</p>
            <div className="">
              <table className="table table-sm table-hover f12">
                  <thead className="bg-secondary-50">
                      <tr>
                        {this.state.sunburstData && Object.entries(this.state.sunburstData).map(([key, value]) => {
                          return(
                            <th>{key}</th>
                          )
                          })}
                      </tr>
                  </thead>
                  <tbody className="bg-white">
                    <tr>
                    {this.state.sunburstData && Object.entries(this.state.sunburstData).map(([key, value]) => {
                      return(
                      <td>{value}</td>
                      )
                    })}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-sm-6" id="hierarchialBarChart" />

          <div className="col-sm-6" id="lollipopChart" />

          <div className="col-sm-6" id="horizontalLollipopChart" />

          <div className="col-sm-6" id="horizontalLimitLollipopChart" />
          
          <div className="col-sm-6" id="lineSvg" />
        </div>
      </div>
    );
  }
}

  /**
 * Type of the props used in the component
 */
  VisGraph.propTypes = {}
  
  /**
 * Map all reducer state to the props of the component
 * @param {Object} state
 */
  const mapStateToProps = state => {}
  
  export default AppWrapper(VisGraph, mapStateToProps, {})